import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-[46px] w-full min-w-0 rounded-full border border-[var(--scaena-control-border)] bg-input px-4 py-2 font-ui text-base [box-shadow:var(--scaena-shadow-control)] outline-none transition-[border-color,box-shadow,background-color] duration-200 file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-[650] file:text-foreground placeholder:text-muted-foreground focus-visible:border-primary/40 focus-visible:bg-white focus-visible:[box-shadow:var(--scaena-shadow-control),var(--scaena-focus-ring)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive/50 aria-invalid:[box-shadow:var(--scaena-shadow-control),0_0_0_3px_rgba(208,55,49,0.12)] md:text-sm",
        className
      )}
      {...props}
    />
  )
}

export { Input }
